import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function CreateBrSquad() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "SQUAD BATTLE ROYALE 😈🔥",
    map: "BERMUDA",
    mode: "Battle Royale",
    entryFee: 0,
    perKill: 0,
    prizePool: 0,
    totalSpots: 48,
    time: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = new Date(Date.now() + 60 * 60 * 1000)
      .toISOString()
      .slice(0, 16);

    setForm((p) => ({ ...p, time: t }));
  }, []);

  useEffect(() => {
    const entry = Number(form.entryFee);
    const afterCut = Math.floor(entry * 0.8);

    setForm((p) => ({
      ...p,
      perKill: afterCut,
      prizePool: afterCut,
    }));
  }, [form.entryFee]);

  const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const createTournament = async () => {
    if (!form.title || !form.time) {
      alert("Fill all fields");
      return;
    }

    setLoading(true);

    try {
      const squadSize = 4;
      const numberOfTeams = form.totalSpots / squadSize;

      const spotsLeft = Array.from(
        { length: numberOfTeams },
        () => squadSize
      );

      await addDoc(collection(db, "br_s_tournaments"), {
        ...form,
        entryFee: Number(form.entryFee),
        perKill: Number(form.perKill),
        prizePool: Number(form.prizePool),
        totalSpots: Number(form.totalSpots),
        time: new Date(form.time),
        spotsLeft,
        team: "Squad",
        roomID: "Coming Soon",
        roomPass: "Coming Soon",
        createdAt: new Date(),
        status: "upcoming",
        winnerDeclared: false,
      });

      alert("Squad Created ✅");
      navigate(-1);
    } catch (e) {
      alert(e.message);
    }

    setLoading(false);
  };

  return (
    <div style={container}>
      <div style={card}>
        <h2 style={title}>🔥 Create BR Squad</h2>

        <Input
          label="Tournament Title"
          name="title"
          value={form.title}
          onChange={handle}
          placeholder="Enter match title"
        />

        <Input
          label="Map"
          name="map"
          value={form.map}
          onChange={handle}
          placeholder="Enter map name"
        />

        <Input
          label="Mode"
          name="mode"
          value={form.mode}
          onChange={handle}
          placeholder="Battle Royale"
        />

        <Input
          label="Entry Fee (₹)"
          name="entryFee"
          type="number"
          value={form.entryFee}
          onChange={handle}
          placeholder="Enter entry fee"
        />

        <Input
          label="Per Kill (Auto)"
          value={form.perKill}
          readOnly
        />

        <Input
          label="Prize Pool (Auto)"
          value={form.prizePool}
          readOnly
        />

        <Input
          label="Total Spots"
          value={form.totalSpots}
          readOnly
        />

        <Input
          label="Match Time"
          name="time"
          type="datetime-local"
          value={form.time}
          onChange={handle}
        />

        <button style={btn} onClick={createTournament}>
          {loading ? "Creating..." : "🚀 Create Tournament"}
        </button>
      </div>
    </div>
  );
}

/* 🔥 INPUT COMPONENT */
function Input({ label, ...props }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={labelStyle}>{label}</label>
      <input {...props} style={input} />
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
};

const card = {
  background: "#1E2235",
  padding: 25,
  borderRadius: 14,
  display: "flex",
  flexDirection: "column",
  gap: 14,
  width: 340,
  color: "#fff",
  boxShadow: "0 0 15px rgba(0,0,0,0.4)",
};

const title = {
  textAlign: "center",
  marginBottom: 10,
};

const labelStyle = {
  fontSize: 12,
  color: "#9CA3AF",
};

const input = {
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #2D334A",
  background: "#111827",
  color: "#fff",
  outline: "none",
};

const btn = {
  marginTop: 10,
  padding: 12,
  border: "none",
  borderRadius: 10,
  background: "#2563EB",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
};

export default CreateBrSquad;